export default "__VITE_ASSET__CYOarB95__"